import React from 'react';
import { func, string, shape, bool, any } from 'prop-types';
import { default as Cb } from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

function Checkbox({ input: { name, onChange, value }, meta, label, required, disabled }) {
  const hasError = meta.error && (meta.touched || !!value);

  return (
    <FormControlLabel
      control={
        <Cb
          error={hasError}
          value={value}
          color="primary"
          name={name}
          onChange={onChange}
          variant="outlined"
          required={required}
          disabled={disabled}
        />
      }
      label={label}
    />
  );
}

Checkbox.propTypes = {
  label: any.isRequired,
  className: string,
  disabled: bool,
  input: shape({
    name: string.isRequired,
    onChange: func.isRequired,
    value: string,
    restInput: shape({}),
  }),
  meta: shape({}),
  required: bool,
};

Checkbox.displayName = 'Checkbox';

export default Checkbox;
